import { View, Text, Link } from '@react-pdf/renderer';
import { infoBoxes } from '../../styles/pdfStyles/infoBoxStyles';
import { BLOCK_EXPLORER_BLOCK_ID_URL, BLOCK_EXPLORER_TXN_ID_URL } from '../../utils/config';
import { formatUTCDate } from '../../utils/converter';

const BlockDetailsPDF = ({ reportData, blockHistory }) => {
  let blockList = blockHistory && blockHistory.length > 0 ? blockHistory : [reportData];

  return (
    <View style={infoBoxes.container}>
      <Text style={infoBoxes.title}>Blockchain Details</Text>
      {blockList.map((block: BlockchainData, index: number) => (
        <View key={index} style={{ marginBottom: 8 }}>
          <View style={[infoBoxes.section, { flexDirection: 'row', backgroundColor: 'lightgrey' }]}>
            <Text style={[infoBoxes.label, { fontWeight: 'bold', width: 140 }]}>Block: </Text>
            <Link style={infoBoxes.link} src={`${BLOCK_EXPLORER_BLOCK_ID_URL}/${block.TXPOW_ID}`}>
              {block.BLOCK}
            </Link>
          </View>

          <View style={[infoBoxes.section, { flexDirection: 'row' }]}>
            <Text style={[infoBoxes.label, { fontWeight: 'bold', width: 140 }]}>Txn ID: </Text>
            <Link
              style={infoBoxes.link}
              src={`${BLOCK_EXPLORER_TXN_ID_URL}/${block.TRANSACTION_ID}`}
            >
              {block.TRANSACTION_ID}
            </Link>
          </View>

          <View style={[infoBoxes.section, { flexDirection: 'row' }]}>
            <Text style={[infoBoxes.label, { fontWeight: 'bold', width: 140 }]}>Date: </Text>
            <Text style={infoBoxes.value}>
              {block.BLOCK_DATE && formatUTCDate(block.BLOCK_DATE)} UTC
            </Text>
          </View>

          <View style={[infoBoxes.section, { flexDirection: 'row' }]}>
            <Text style={[infoBoxes.label, { fontWeight: 'bold', width: 140 }]}>Coin ID: </Text>
            <Text style={infoBoxes.value}>{block?.COIN_ID || '-'}</Text>
          </View>
        </View>
      ))}
    </View>
  );
};

export default BlockDetailsPDF;
